import React, { Component } from 'react';

import { Form } from 'components';

class CustomForm extends Component {
  state = {
    data: this.props.data,
  };

  componentDidUpdate(oldProps, oldState) {
    const { data } = this.state;
    const { onChange } = this.props;

    if (oldProps.data !== this.props.data) {
      this.setState({ data: this.props.data });
    }

    if (oldState.data !== data) {
      onChange(data);
    }
  }

  handleChangeInput = e => {
    const { data } = this.state;
    const { name, value } = e.target;

    this.setState({ data: { ...data, [name]: value } });
  };

  handleChangeSelect = (name, value) => {
    const { data } = this.state;

    this.setState({ data: { ...data, [name]: value } });
  };

  handleTriggerSearchParticipants = value => {
    if (value !== null && value !== '') {
      this.handleSearchParticipants(value);
    }
  };

  render() {
    const { data } = this.state;
    const { errors } = this.props;

    return (
      <Form onSubmit={this.onSubmit}>
        <div className="row">
          <div className="col-6">
            <Form.Group>
              <Form.Label>Nome</Form.Label>
              <Form.Input
                name="name"
                placeholder="Nome da jornada"
                focus={1}
                value={data.name}
                errors={errors.name}
                onChange={this.handleChangeInput}
              />
            </Form.Group>
          </div>

          <div className="col-6">
            <Form.Group>
              <Form.Label>Descrição</Form.Label>
              <Form.Input
                name="description"
                placeholder="Descrição da jornada"
                value={data.description}
                errors={errors.description}
                onChange={this.handleChangeInput}
              />
            </Form.Group>
          </div>

          <div className="col-6">
            <Form.Group>
              <Form.Label>Data de início</Form.Label>
              <Form.DatePicker
                name="available_from"
                placeholderText="Data"
                timeFormat="HH:mm"
                dateFormat="dd/MM/yyyy HH:mm"
                timeCaption="Hora"
                showTimeSelect
                timeIntervals={15}
                errors={errors.available_from}
                selected={data.available_from}
                ref={input => {
                  this.input = input;
                }}
                onChange={value => this.handleChangeSelect('available_from', value)}
              />
            </Form.Group>
          </div>

          <div className="col-6">
            <Form.Group>
              <Form.Label>Data de término</Form.Label>
              <Form.DatePicker
                name="available_until"
                placeholderText="Data"
                timeFormat="HH:mm"
                dateFormat="dd/MM/yyyy HH:mm"
                timeCaption="Hora"
                showTimeSelect
                timeIntervals={15}
                errors={errors.available_until}
                selected={data.available_until}
                ref={input => {
                  this.input = input;
                }}
                onChange={value => this.handleChangeSelect('available_until', value)}
              />
            </Form.Group>
          </div>

          <div className="col-6">
            <Form.Group>
              <Form.Label>Face norte</Form.Label>
              <Form.Select
                placeholder="Questionário da face norte"
                options={[]}
                value={data.north_face_quiz}
                errors={errors.north_face_quiz}
                onChange={value => this.handleChangeSelect('north_face_quiz', value)}
              />
            </Form.Group>
          </div>

          <div className="col-6">
            <Form.Group>
              <Form.Label>Face sul</Form.Label>
              <Form.Select
                placeholder="Questionário da face sul"
                options={[]}
                value={data.south_face_quiz}
                errors={errors.south_face_quiz}
                onChange={value => this.handleChangeSelect('south_face_quiz', value)}
              />
            </Form.Group>
          </div>

          <div className="col-6">
            <Form.Group>
              <Form.Label>Face leste</Form.Label>
              <Form.Select
                placeholder="Questionário da face leste"
                options={[]}
                value={data.east_face_quiz}
                errors={errors.east_face_quiz}
                onChange={value => this.handleChangeSelect('east_face_quiz', value)}
              />
            </Form.Group>
          </div>

          <div className="col-6">
            <Form.Group>
              <Form.Label>Face oeste</Form.Label>
              <Form.Select
                placeholder="Questionário da face oeste"
                options={[]}
                value={data.west_face_quiz}
                errors={errors.west_face_quiz}
                onChange={value => this.handleChangeSelect('west_face_quiz', value)}
              />
            </Form.Group>
          </div>
        </div>
      </Form>
    );
  }
}

CustomForm.defaultProps = {
  isUpdate: false,
};

export default CustomForm;



// WEBPACK FOOTER //
// ./src/pages/Admin/Journeys/components/Form/index.js